import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  fetchFeatureMatrix,
  toggleFeatureMapping,
  fetchFeaturesCatalog,
  createFeature,
  updateFeature,
} from '@/api/features';
import type { FeatureCreatePayload, FeatureUpdatePayload, FeatureToggleRequest } from '@/types/features';

export function useFeaturesMatrix() {
  return useQuery({
    queryKey: ['crm', 'features', 'matrix'],
    queryFn: fetchFeatureMatrix,
  });
}

export function useFeaturesCatalog() {
  return useQuery({
    queryKey: ['crm', 'features', 'list'],
    queryFn: fetchFeaturesCatalog,
  });
}

export function useToggleFeature() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: FeatureToggleRequest) => toggleFeatureMapping(body),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['crm', 'features', 'matrix'] });
    },
  });
}

export function useCreateFeature() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: FeatureCreatePayload) => createFeature(body),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['crm', 'features'] });
    },
  });
}

export function useUpdateFeature() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ key, body }: { key: string; body: FeatureUpdatePayload }) => updateFeature(key, body),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['crm', 'features'] });
    },
  });
}
